module.exports = __webpack_public_path__ + "img/delete.77e4245a.svg";